import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from '../../helpers/matomo';
import History from "./History";
import Pending from "./Pending";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AprovationTabs() {
  const { t } = useTranslation("translation");
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEventMatomo('aprovações', 'click', 'aba', newValue === 0 ? 'aprovações pendentes' : 'histórico de aprovações');
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs textColor="secondary" indicatorColor="secondary" value={value} onChange={handleChange}>
          <Tab label={t("Aprovations.aprovacoes_pendentes")} value={0} />
          <Tab label={t("Aprovations.historico")} value={1} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Pending />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <History />
      </CustomTabPanel>
    </>
  );
}
